export function normalizeBuilderData(data) {
  return {
    tableData: data,
    modalData: data,
  };
}
